import { render } from "./OrderInfoModal.vue?vue&type=template&id=03946ddc&scoped=true"
import script from "./OrderInfoModal.vue?vue&type=script&lang=js"
export * from "./OrderInfoModal.vue?vue&type=script&lang=js"

import "./OrderInfoModal.vue?vue&type=style&index=0&id=03946ddc&scoped=true&lang=css"

import exportComponent from "G:\\dev\\OSPanel\\domains\\arenda-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03946ddc"]])

export default __exports__